/* import React, { useEffect, useState } from "react"; */
import PoolsWidget from "./PoolsWidget";
import ArticlesElement from "./ArticlesElement";

const HomePage = () => {
  /* const [SportsExpress, setSportsExpress] = useState(""); */

  /* useEffect(() => {
    (async () => {
      const loadSportsExpress = async () => {
        const link = (await (await fetch(`/api/GetSportsExpress`)).json()).value[0].url;
        setSportsExpress(link);
      };
      loadSportsExpress();
    })();
  }, []); */

  return (
    <div style={{ paddingLeft: "0.3em" }}>
      <PoolsWidget />
      <ArticlesElement />
      {/*
      <div className="row third">
        <div>
          <a href={SportsExpress} target="_blank" rel="noopener noreferrer">
            <img alt="Sports Express" src="/images/Sports_Express.jpg" style={{ width: "100%", height: "10%" }} />
          </a>
          <br />
          <br />
        </div>
      </div>
      <div className="row fourth">
        <div className="large-6 columns smallpaddingright">
          <div className="sectionheader nospace">General Info</div>
          <div className="flex-video">
            <iframe width={252} height={206} src="https://www.youtube.com/embed/2sWEJb_6jZE?rel=0" title="General Info"></iframe>
          </div>
        </div>
        <div className="large-6 columns smallpaddingleft">
          <div className="sectionheader nospace">PROMO</div>
          <div className="flex-video">
            <iframe width={252} height={206} src="https://www.youtube.com/embed/WjWXNPK0G_Y?rel=0" title="General Info"></iframe>
          </div>
        </div>
      </div> */}
      <div className="large-4 columns" style={{ paddingLeft: "3px", paddingRight: "0" }}></div>
    </div>
  );
};

export default HomePage;
